import { action, observable, computed } from 'mobx';
import UnderLyingEnum from '../@enums/UnderLyingEnum';

export class Underlying {
  // 项目仅支持 U 本位
  underlyinges = [UnderLyingEnum.U_BASED];

  @observable currentUnderlying = UnderLyingEnum.U_BASED;

  @action.bound
  setCurrentUnderLying(_value: UnderLyingEnum): void {
    this.currentUnderlying = UnderLyingEnum.U_BASED;
  }

  @computed get isUBased(): boolean {
    return this.currentUnderlying === UnderLyingEnum.U_BASED;
  }
}
export default new Underlying();
